/**
 * References page: hero fade-in.
 */
const SELECTORS = {
    hero: '[data-references-hero]',
};
export function initReferencesPage() {
    const hero = document.querySelector(SELECTORS.hero);
    if (!hero) {
        return;
    }
    requestAnimationFrame(() => {
        hero.classList.add('is-visible');
    });
}
